// extracted by mini-css-extract-plugin
export default {"toggleWrapper":"styles_toggleWrapper__JZeyE","toggleButton":"styles_toggleButton__cjS9l","active":"styles_active__3hbsP"};